module.exports = __webpack_public_path__ + "img/ic_happytable_play.1279b57e.png";